import { toast } from "sonner"

export const useToast = () => {
  return {
    // Toast de success
    success: (message: string, description?: string) => {
      if (description) {
        toast.success(message, { description })
      } else {
        toast.success(message)
      }
    },

    // Toast d'error
    error: (message: string, description?: string) => {
      if (description) {
        toast.error(message, { description })
      } else {
        toast.error(message)
      }
    },

    // Toast d'informació
    info: (message: string, description?: string) => {
      if (description) {
        toast.info(message, { description })
      } else {
        toast.info(message)
      }
    },

    // Toast d'advertència
    warning: (message: string, description?: string) => {
      if (description) {
        toast.warning(message, { description })
      } else {
        toast.warning(message)
      }
    },

    // Toast de loading
    loading: (message: string) => {
      return toast.loading(message)
    },

    // Toast personalitzat
    custom: (message: string, options: any = {}) => {
      toast(message, options)
    },

    // Promesa amb toast automàtic
    promise: (promise: Promise<any>, messages: { loading?: string; success?: string; error?: string }) => {
      return toast.promise(promise, {
        loading: messages.loading || 'Carregant...',
        success: messages.success || 'Completat!',
        error: messages.error || 'Error!'
      })
    },

    // Dismiss tots els toasts
    dismiss: (toastId?: string | number) => {
      if (toastId) {
        toast.dismiss(toastId)
      } else {
        toast.dismiss()
      }
    }
  }
}
